import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class PaymentCreditEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      registration: null,
      operation_type_id: null,
      serial_number: null,
      ptbr_code: null,
      ca: null,
      iam: null,
      aircraft_models_list: [],
      operation_types: [],
      aircraft_model_id: null,
      daily_currency_list: [
        {value: "EUR", label: "Euro"},
        {value: "USD", label: "Dólar"},
        {value: "BRL", label: "Real"},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/pagamento/saldo/credito/'+ self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/aeronave/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            staff_id: responseJson.data.staff_id,
            staff: responseJson.data.staff,
            schedule_id: responseJson.data.schedule_id,
            schedule: responseJson.data.schedule,
            training_id: responseJson.data.training_id,
            training: responseJson.data.training,
            daily_total: responseJson.data.daily_total_str,
            daily_currency: responseJson.data.daily_currency,
            remaining: responseJson.data.remaining,
            type: responseJson.data.type_str,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/colaboradores/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staffs_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      id: this.state.id,
      daily_total: this.state.daily_total,
      daily_currency: this.state.daily_currency,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/saldo/credito/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar crédito</h3>
      <Link to="/saldo/devedor" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>Tripulante:</label>
              <br/>{this.state.staff}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Escala / Grade:</label>
              <br/>{this.state.schedule}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Treinamento:</label>
              <br/>{this.state.training}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>Tipo:</label>
              <br/>{this.state.type}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Valor total:</label>
              <br/>{this.state.daily_total}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Diária moeda:</label>
              <br/>{this.state.daily_currency}
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentCreditEdit;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentCreditEdit.js